module.exports = __webpack_public_path__ + "static/media/circular-checkbox-selected.1c04017b.svg";